import React, { useState, useEffect } from "react";
import { Redirect, Route, useLocation } from "react-router-dom";
import { useAuth } from "~/state/auth/AuthContext";
import { verifyAuthCode, sendTokenFirebase } from "~/services/loginService";
import { getMe } from "~/services/meServices";

export default function PrivateRoute({ children, meta, ...rest }) {
    const { isAuthenticated } = useAuth();
    const location = useLocation();
    const [authCodeStatus, setAuthCodeStatus] = useState('idle'); // 'idle' | 'loading' | 'done'

    const checkAuthFromStorage = () => {
        const meData = localStorage.getItem("@prit-web/meData");
        const userId = localStorage.getItem("@prit-web/userId");
        return !!(meData && userId);
    };

    const isUserAuthenticated = isAuthenticated || checkAuthFromStorage();
    const searchParams = new URLSearchParams(location.search);
    const authCode = searchParams.get('auth_code');

    useEffect(() => {
        if (!authCode || isUserAuthenticated || authCodeStatus !== 'idle') return;

        setAuthCodeStatus('loading');
        window.__PRIT_CODE_LOGIN_IN_PROGRESS__ = true;

        verifyAuthCode(authCode)
            .then(response => {
                if (response.data?.status === 'OK') {
                    return sendTokenFirebase(response.data.message);
                }
                throw new Error('INVALID_CODE');
            })
            .then(() => getMe())
            .then(meResponse => {
                const userData = meResponse?.data;
                if (userData) {
                    localStorage.setItem("@prit-web/meData", JSON.stringify(userData));
                    if (userData.id) {
                        localStorage.setItem("@prit-web/userId", userData.id);
                    }
                }
                const btIdMatch = location.pathname.match(/\/bookingTransactionId\/([^/]+)/);
                const bookingTransactionId = btIdMatch?.[1];
                if (bookingTransactionId) {
                    localStorage.setItem("@prit-web/bookingTransactionId", bookingTransactionId);
                }
            })
            .catch(() => {
                window.__PRIT_CODE_LOGIN_IN_PROGRESS__ = false;
            })
            .finally(() => {
                setAuthCodeStatus('done');
            });
    }, [authCode, isUserAuthenticated, authCodeStatus]);

    return (
        <Route
            {...rest}
            render={({ location: routeLocation, match }) => {
                if (isUserAuthenticated) return children;
                if (authCode && authCodeStatus === 'loading') return null;

                const redirectState = {
                    ...routeLocation.state,
                    goBackRoute: routeLocation.pathname,
                    goBackRouteProps: {
                        ...routeLocation.state,
                        bookingTransactionId: match?.params?.bookingTransactionId,
                        businessId: match?.params?.id,
                        bookingId: match?.params?.bookingId,
                    },
                };

                if (meta?.flow === "schedule" && match?.params?.id) {
                    return <Redirect to={{ pathname: "/business/link", state: redirectState }}/>
                }

                return <Redirect to={{ pathname: "/business/link", state: redirectState }}/>
            }}
        />
    )
}